import {ROUTES} from '../../../config'

export const getInitialProps = async ({
  routeInfo,
  context: {
    i18n: {culture},
    domain
  }
}) => {
  const config = domain.get('config')
  const {DEFAULT_SEARCH: defaultSearch} = config.get('technicalDetails')
  const {
    ERRORS: {GetPaginationSearchUrlVehiclesError}
  } = config.get('COMMON')

  const {
    location: {
      pathname: path,
      search: searchFromUrl,
      query: {or = defaultSearch.sortOrder, fi = defaultSearch.sortBy, pg = defaultSearch.page, ...restQuery},
      state
    },
    location
  } = routeInfo

  const initialQuery = {or, fi, pg, ...restQuery}

  const route = `${path}${searchFromUrl}`

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: route})

  const searchRequest = await domain
    .get('get_search_request_vehicles_use_case')
    .execute({query: initialQuery, pageName})

  const [initialResultsError, initialResultsResponse] = await domain
    .get('get_search_results_vehicles_use_case')
    .execute({search: searchRequest})

  const {meta: {totalPages} = {}} = initialResultsResponse || {}

  const [[paginationSearchUrlError, {url}], [, breadcrumb], [seoDataError, {head: helmet} = {}]] = await Promise.all([
    domain.get('get_pagination_search_url_vehicles_use_case').execute({
      pageName,
      search: searchRequest,
      queryPlaceholder: {
        query: 'pg',
        placeholder: '%{pageNumber}'
      }
    }),
    domain.get('get_breadcrumbs_breadcrumb_use_case').execute({pageName}),
    domain.get('get_seo_data_use_case').execute({
      culture,
      pageName,
      params: {
        totalPages,
        page: searchRequest.page,
        sortBy: searchRequest.sortBy,
        sortOrder: searchRequest.sortOrder
      }
    })
  ])

  const technicalDetailsHomeURL = `${ROUTES.TECHNICAL_DETAILS.INDEX}/`
  const technicalDetailsSearchURL = `${ROUTES.TECHNICAL_DETAILS.SEARCH}/`

  let redirectTo
  if (initialResultsError) {
    redirectTo = technicalDetailsSearchURL
  } else if (paginationSearchUrlError instanceof GetPaginationSearchUrlVehiclesError) {
    redirectTo = technicalDetailsHomeURL
  }

  return {
    ...(redirectTo && {__HTTP__: {redirectTo}}),
    helmet,
    breadcrumb,
    pageName,
    location,
    search: searchRequest,
    initialResultsResponse,
    paginationUrl: url,
    lastFilter: state?.lastFilter,
    pageErrors: {
      initialResultsError,
      paginationSearchUrlError,
      seoDataError
    }
  }
}
